import { useContext, useState } from "react";
import CardGoal from "../../components/boxes/CardGoal";
import goal1Image from "../../assets/images/slider/goal1.png";
import goal2Image from "../../assets/images/slider/goal2.png";
import goal3Image from "../../assets/images/slider/primary-logo.svg";

import globalGoal8 from "../../assets/images/slider/global-goal-8.svg";
import globalGoal12 from "../../assets/images/slider/global-goal-12.svg";
import globalGoal3 from "../../assets/images/slider/global-goal-3.svg";
import globalGoal4 from "../../assets/images/slider/global-goal-4.svg";
import globalGoal5 from "../../assets/images/slider/global-goal-5.svg";
import globalGoal10 from "../../assets/images/slider/global-goal-10.svg";
import globalGoal11 from "../../assets/images/slider/global-goal-11.svg";
import globalGoal9 from "../../assets/images/slider/global-goal-9.svg";
import globalGoal7 from "../../assets/images/slider/global-goal-7.svg";
import globalGoal13 from "../../assets/images/slider/global-goal-13.svg";

import globalGoalAr3 from "../../assets/images/slider/global-goal-ar-3.svg";
import globalGoalAr4 from "../../assets/images/slider/global-goal-ar-4.svg";
import globalGoalAr5 from "../../assets/images/slider/global-goal-ar-5.svg";
import globalGoalAr7 from "../../assets/images/slider/global-goal-ar-7.svg";
import globalGoalAr8 from "../../assets/images/slider/global-goal-ar-8.svg";
import globalGoalAr9 from "../../assets/images/slider/global-goal-ar-9.svg";
import globalGoalAr10 from "../../assets/images/slider/global-goal-ar-10.svg";
import globalGoalAr11 from "../../assets/images/slider/global-goal-ar-11.svg";
import globalGoalAr12 from "../../assets/images/slider/global-goal-ar-12.svg";
import globalGoalAr13 from "../../assets/images/slider/global-goal-ar-13.svg";


import VerticalCarousel from "./VerticalCarousel";
import { setAdditionalClasses } from "../../utils/utils";
import { LangContext } from "../../App";

const VisionCarousel = () => {
  const { lang } = useContext(LangContext)

  const [hideGoalNumber, setHideGoalNumber] = useState<number[]>([]);
  const [activeHover, setActiveHover] = useState(false);
  const handleHideGoals = (globalGoalNumbers: number[] = []) => {
    setHideGoalNumber(globalGoalNumbers);
    setActiveHover(true);
    if (globalGoalNumbers.length == 0) {
      setActiveHover(false);
    }
  };

  return (
    <div className="wrapper-small">
      <div className="slider-wrapper-two">
        <div style={{ padding: "100px", maxWidth: "100%" }}>
          <div className="grid-3 gap-20 grid-bottom">
            <div></div>
            <img alt="" src={goal2Image} className="image-grid" />
            <div>
              <img alt="" src={goal3Image} className="image-grid" />
            </div>
          </div>
          {
          !lang ?
          <p className="arrow-instruction grid-bottom">
            Click the arrow buttons to see how SAB achieves the Vision 2030
            objectives by aligning with UNSDGs
          </p> :
          <p className="arrow-instruction grid-bottom">
            انقر على الأسهم لمعرفة كيف يحقق  بنك الأول رؤية السعودية 2030 وأهداف الأمم المتحدة للتنمية المستدامة
          </p>
          }
          <VerticalCarousel
            items={[
              <div className={`grid-3 gap-20 fixed-grid-height ${lang ? "rtl" : ""}`}>
                <div className={`goals-container`}>
                  <img alt="" src={goal1Image} className="image-grid" />
                  <div className="flex-column gap-20 ">
                    <img
                      alt=""
                      src={!lang ? globalGoal8 : globalGoalAr8}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(8),
                          activeHover && !hideGoalNumber.includes(8),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal12 : globalGoalAr12}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(12),
                          activeHover && !hideGoalNumber.includes(12),
                        ]
                      )}`}
                    />
                  </div>
                </div>
                <div className="flex-column gap-20 ">
                  <p
                    onMouseEnter={() => handleHideGoals([12])}
                    onMouseLeave={() => handleHideGoals([])}
                    className="bordered-box"
                  >
                    {
                    !lang ?
                    "Financial Sector Development" :
                    "برنامج تطوير القطاع المالي"
                    }
                  </p>
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([12])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "National Transformation":
                    "برنامج التحول الوطني "}
                  </p>
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([111])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Privatisation Programme":
                    "برنامج التخصيص"}
                  </p>
                </div>
                <ul className="list ">
                  <li>
                    {
                      !lang ?
                      "Rollout of various digital services and features" : 
                      "طرح العديد من الخدمات والمميزات الرقمية"
                    }
                  </li>
                  <li>
                    {!lang ?
                    "Employee culture and engagement initiatives " : 
                    "مبادرات ثقافة الموظفين وتعزيز المشاركة"}
                  </li>
                  <li>
                    {!lang ?
                    "Green bank cards largely made up of recycled plastic – over 240,000 in circulation" :
                    "البطاقات المصرفية الخضراء، والمصنوعة بنسبة كبيرة من البلاستيك المعاد تدويره - صدر منها أكثر من "}
                  </li>
                </ul>
              </div>,
              <div className={`grid-3 gap-20 fixed-grid-height ${lang ? "rtl" : ""}`}>
                <div className="goals-container">
                  <img alt="" src={goal1Image} className="image-grid" />
                  <div className="grid-2-2 gap-20 max-100 max-height-100">
                    <img
                      alt=""
                      src={!lang ? globalGoal3 : globalGoalAr3}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(3),
                          activeHover && !hideGoalNumber.includes(3),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal4 : globalGoalAr4}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(4),
                          activeHover && !hideGoalNumber.includes(4),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal5 : globalGoalAr5}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(5),
                          activeHover && !hideGoalNumber.includes(5),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal10 : globalGoalAr10}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(10),
                          activeHover && !hideGoalNumber.includes(10),
                        ]
                      )}`}
                    />
                  </div>
                </div>
                <div className="flex-column gap-20 max-10 flex-wrap">
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([3])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Human Capability Development" :
                    "برنامج تنمية القدرات البشرية"}
                  </p>
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([4, 5, 10])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Health Sector Transformation" :
                    "برنامج تحول القطاع الصحي "}
                  </p>
                </div>
                <ul className="list max-100">
                  <li>
                    {!lang ?
                    "Saudi Food Bank and other nutritional initiatives":
                    "بنك الطعام السعودي والمبادرات الغذائية الأخرى"} 
                  </li>
                  <li>
                    {!lang ?
                    "Riyali financial literacy programme" :
                    'برنامج "ريالي" للوعي المالي'}
                  </li>
                  <li>
                    {!lang ?
                    "Women empowerment initiatives" :
                    "مبادرات تمكين المرأة"}
                  </li>
                </ul>
              </div>,
              <div className={`grid-3 gap-20 fixed-grid-height ${lang ? "rtl" : ""}`}>
                <div className="goals-container">
                  <img alt="" src={goal1Image} className="image-grid" />
                  <div className="flex-column gap-20 ">
                    <img
                      alt=""
                      src={!lang ? globalGoal9 : globalGoalAr9}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(9),
                          activeHover && !hideGoalNumber.includes(9),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal11 : globalGoalAr11}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(11),
                          activeHover && !hideGoalNumber.includes(11),
                        ]
                      )}`}
                    />
                  </div>
                </div>
                <div className="flex-column gap-20 ">
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([9])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Housing Programme" :
                    "برنامج الإسكان"}
                  </p>
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([111])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Public Investment Fund" :
                    "برنامج صندوق الاستثمارات العامة"}
                  </p>
                </div>
                <ul className="list ">
                  <li>
                    {!lang ?
                    "Tarmeem house renovation programme for needy families" :
                    "جمعية ترميم المتخصصة في ترميم منازل الأسر الأشد حاجة"} 
                  </li>
                  <li>
                    {!lang ?
                    "SAB participated in a SAR 6 billion revolving working capital facility for ROSHN – a national real estate developer wholly owned by the Public Investment Fund (PIF)" :
                    "كان بنك الأول من بين المؤسسات المالية المشاركة في منح تسهيلات ائتمانية لرأس المال العامل بقيمة 6 مليارات ريال سعودي لصالح شركة روشن العقارية - المطور العقاري الوطني المملوك بالكامل لصندوق الاستثمارات العامة"}
                  </li>
                </ul>
              </div>,
              <div className={`grid-3 gap-20 fixed-grid-height ${lang ? "rtl" : ""}`}>
                <div className="goals-container">
                  <img alt="" src={goal1Image} className="image-grid" />
                  <div className="flex-column gap-20 ">
                    <img
                      alt=""
                      src={!lang ? globalGoal13 : globalGoalAr13}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(13),
                          activeHover && !hideGoalNumber.includes(13),
                        ]
                      )}`}
                    />
                    <img
                      alt=""
                      src={!lang ? globalGoal7 : globalGoalAr7}
                      className={`image-global-goal${setAdditionalClasses(
                        ["hide", "show"],
                        [
                          hideGoalNumber.includes(7),
                          activeHover && !hideGoalNumber.includes(7),
                        ]
                      )}`}
                    />
                  </div>
                </div>
                <div className="flex-column gap-20 ">
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([13])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "National Industrial Development and Logistics Programme" :
                    "برنامج تطوير الصناعة الوطنية والخدمات اللوجستية"}
                  </p>
                  <p
                    className="bordered-box"
                    onMouseEnter={() => handleHideGoals([7])}
                    onMouseLeave={() => handleHideGoals([])}
                  >
                    {!lang ?
                    "Saudi Green Initiative: Reducing Emissions target" :
                    "مبادرة السعودية الخضراء: هدف تقليل الانبعاثات"}
                  </p>
                </div>
                <ul className="list ">
                  <li>
                  {!lang ?
                  "Finance the sustainable growth of our commercial customers" :
                  "تمويل النمو المستدام لعملائنا في القطاع التجاري"}
                  </li>
                  <li>
                  {!lang ?
                  "Be the go-to bank for ESG in the Kingdom" : 
                  "البنك المفضل في المملكة للممارسات البيئية والاجتماعية والحوكمة المؤسسية"}
                  </li>
                  <li>
                    {!lang ?
                    "50,000 trees planted so far as part of SGI" :
                    "زراعة 50 ألف شجرة حتى الآن ضمن مبادرة السعودية الخضراء"}
                  </li>
                  <li>
                    {!lang ?
                    "Supported Sudair Solar Power project with SAR 300 million in financing" :
                    "دعم مشروع سدير للطاقة الشمسية بتمويل قدره 300 مليون ريال سعودي"}
                  </li>
                </ul>
              </div>,
            ]}
          />
        </div>
      </div>
      <div className="slider-wrapper-one">
        <CardGoal
          imageHeaders={[goal1Image, goal2Image, goal3Image]}
          globalsImages={!lang ? [globalGoal8, globalGoal12] : [globalGoalAr8, globalGoalAr12]}
          borderTexts={!lang ? [
            "Financial Sector Development",
            "National Transformation",
            "Privatisation Programme",
          ]: [
            "برنامج تطوير القطاع المالي",
            "برنامج التحول الوطني ",
            "برنامج التخصيص",
          ]}
          listTexts={!lang ? [
            "Rollout of various digital services and features",
            "Employee culture and engagement initiatives",
            "Green bank cards largely made up of recycled plastic – over 240,000 in circulation",
          ] :[
              "طرح العديد من الخدمات والمميزات الرقمية",
              "مبادرات ثقافة الموظفين وتعزيز المشاركة",
              "البطاقات المصرفية الخضراء، والمصنوعة بنسبة كبيرة من البلاستيك المعاد تدويره - صدر منها أكثر من 240,000"
          ]}
        />
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <CardGoal
          imageHeaders={[goal1Image, goal2Image, goal3Image]}
          globalsImages={!lang ? [globalGoal3, globalGoal4, globalGoal5, globalGoal10] : [globalGoalAr3, globalGoalAr4, globalGoalAr5, globalGoalAr10]}
          borderTexts={!lang ?[
            "Human Capability Development",
            "Health Sector Transformation",
          ] : [
            "برنامج تنمية القدرات البشرية",
            "برنامج تحول القطاع الصحي ",
          ]}
          listTexts={!lang ? [
            "Saudi Food Bank and other nutritional initiatives ",
            "Riyali financial literacy programme",
            "Women empowerment initiatives",
          ] : [
            "بنك الطعام السعودي والمبادرات الغذائية الأخرى",
            'برنامج "ريالي" للوعي المالي',
            "مبادرات تمكين المرأة"
          ]}
        />
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <CardGoal
          imageHeaders={[goal1Image, goal2Image, goal3Image]}
          globalsImages={!lang ? [globalGoal9, globalGoal11] : [globalGoalAr9, globalGoalAr11]}
          borderTexts={!lang ? [
            "Housing Programme", 
            "Public Investment Fund"
          ] : [
            "برنامج الإسكان ",
            "برنامج صندوق الاستثمارات العامة",
          ]}
          listTexts={!lang ? [
            "Tarmeem house renovation programme for needy families",
            "SAB participated in a SAR 6 billion revolving working capital facility for ROSHN – a national real estate developer wholly owned by the Public Investment Fund (PIF)"
          ] : [
            "جمعية ترميم المتخصصة في ترميم منازل الأسر الأشد حاجة",
            "كان بنك الأول من بين المؤسسات المالية المشاركة في منح تسهيلات ائتمانية لرأس المال العامل بقيمة 6 مليارات ريال سعودي لصالح شركة روشن العقارية - المطور العقاري الوطني المملوك بالكامل لصندوق الاستثمارات العامة",
          ]}
        />
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <CardGoal
          imageHeaders={[goal1Image, goal2Image, goal3Image]}
          globalsImages={!lang ? [globalGoal13, globalGoal7] : [globalGoalAr13, globalGoalAr7]}
          borderTexts={!lang ? [
            "National Industrial Development and Logistics Programme",
            "Saudi Green Initiative: Reducing Emissions target",
          ] : [
            "برنامج تطوير الصناعة الوطنية والخدمات اللوجستية ",
            "مبادرة السعودية الخضراء: هدف تقليل الانبعاثات"
          ]}
          listTexts={!lang ? [
            "Finance the sustainable growth of our commercial customers",
            "Be the go-to bank for ESG in the Kingdom",
            "50,000 trees planted so far as part of SGI",
            "Supported Sudair Solar Power project with SAR 300 million in financing",
          ] : [
            "تمويل النمو المستدام لعملائنا في القطاع التجاري",
            "البنك المفضل في المملكة للممارسات البيئية والاجتماعية والحوكمة المؤسسية            ",
            "زراعة 50 ألف شجرة حتى الآن ضمن مبادرة السعودية الخضراء",
            "دعم مشروع سدير للطاقة الشمسية بتمويل قدره 300 مليون ريال سعودي",
          ]}
        />
      </div>
    </div>
  );
};

export default VisionCarousel;
